import React from "react";
import "./Add_On_Benifits_Component.css";

const Add_On_Benifits_Component = ({ val, IMG_URL }) => {
  return (
    <div className="Add_On_Benifits_Component">
      <div className="benifits_main_div free_benifits_div">
        <p className="main_heading_text"> Free Benifits </p>

        {val?.f_i_add_ons
          ?.filter((addOn) => addOn.type === "Free")
          .map((val1) => (
            <>
              <div className="sub_heading_div">
                <p className="sub_heading">{val1?.name}</p>
                <p className="green_round_text">free</p>
              </div>

              <p className="descn_text">{val1?.description}</p>
            </>
          ))}

        {/* <div className='sub_heading_div'>
                    <p className='sub_heading'>
                        Option to delay 12 months premium
                    </p>

                    <p className='green_round_text'>
                        free
                    </p>
                </div>

                <p className='descn_text'>You get the option to defer* your premiums for 12 months after 3 policy years without any additional premium or interest charged. *This option can be availed multiple times in gap of 5 years.</p> */}

        {/* <div className='sub_heading_div'>
                    <p className='sub_heading'>
                        Free health benefits upto ₹31,000/yr
                    </p>
                    <p className='green_round_text'>
                        free
                    </p>
                </div>

                <p className='descn_text'>Free health benefits are provided to the life assured which intends to incentivize him/her for taking care of his/her health/fitness & maintaining healthy lifestyle through such preventative and wellness services.</p>


                <div className='sub_heading_div'>
                    <p className='sub_heading'>
                        Get your premium back during age of 60-64 years
                    </p>
                </div>

                <p className='descn_text'>As per your age you can exit the policy during the age of 60-64 years. All premiums paid (excluding GST) shall be returned & the policy will get terminated.</p> */}
      </div>

      <div className="benifits_main_div paid_benifits_div">
        <p className="main_heading_text"> Paid Benefits </p>
        {val?.f_i_add_ons
          ?.filter((addOn) => addOn.type === "Paid")
          .map((val1) => (
            <>
              <div className="sub_heading_div">
                <p className="sub_heading">{val1?.name}</p>

                <p className="green_round_text red">₹ {val1?.rate}/Month</p>
              </div>
              <p className="descn_text">
                {val1?.decription}
              </p>{" "}
            </>
          ))}

        {/* <div className="sub_heading_div">
          <p className="sub_heading">Free health benefits upto ₹31,000/yr</p>

          <p className="green_round_text red">₹ 82/Month</p>
        </div>

        <p className="descn_text">
          In case policyholder is permanently disabled due to an accident, an
          additional payout of Rs. 25 Lac will be paid.
        </p> */}
      </div>
    </div>
  );
};

export default Add_On_Benifits_Component;
